<section class="d-body  hidden">
  <iq-central-front-end-navbar></iq-central-front-end-navbar>
  <div class="container">
    <div
      class="row align-items-center sm-reverse table-search-container mt-5 mb-2"
    >
      <div
        class="text-green font12 font-bold col-lg-2 col-sm-12 sm-text-center sm-mt sm-mb-2 py-3 mr-auto"
      >
        <!-- <span class="font14 text-grey mr-3">Add Filter</span> -->
        <span class="dropdown click">
          <span
            class="font-bold text-green font12 dropdown-toggle"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            >Add Filter
          </span>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item click line-under">Name</a>
            <a class="dropdown-item click">Class</a>
            <a class="dropdown-item click">State</a>
          </div>
        </span>
      </div>

      <div class="table-search col-lg-7 col-sm-12">
        <input type="text" placeholder="Search" />
      </div>
      <div class="sort col-lg-3 col-sm-12 sm-mt sm-mb-2 sm-text-center">
        <span class="font14 text-grey mr-3">sort by</span>
        <span class="dropdown click">
          <span
            class="font-bold text-green font12 dropdown-toggle"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            >Name <i class="fa fa-chevron-down"></i
          ></span>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item click line-under">Name</a>
            <a class="dropdown-item click">Class</a>
            <a class="dropdown-item click">State</a>
          </div>
        </span>
      </div>
    </div>

    <div class="py-5">
      <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
        <!-- <li class="nav-item">
          <a
            class="nav-link active"
            id="pills-LearningHistory-tab"
            data-toggle="pill"
            href="#pills-LearningHistory"
            role="tab"
            aria-controls="pills-LearningHistory"
            aria-selected="true"
            >Learning History</a
          >
        </li> -->
        <!-- <li class="nav-item">
          <a
            class="nav-link"
            id="pills-InProgress-tab"
            data-toggle="pill"
            href="#pills-InProgress"
            role="tab"
            aria-controls="pills-InProgress"
            aria-selected="false"
            >In Progress</a
          >
        </li> -->
        <li class="nav-item">
          <a
            class="nav-link  show active"
            id="pills-EnrolledCourses-tab"
            data-toggle="pill"
            href="#pills-EnrolledCourses"
            role="tab"
            aria-controls="pills-EnrolledCourses"
            aria-selected="false"
            >Enrolled Courses</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            id="pills-LearningPath-tab"
            data-toggle="pill"
            href="#pills-LearningPath"
            role="tab"
            aria-controls="pills-LearningPath"
            aria-selected="false"
            >Assigned Learning Paths</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            id="pills-AssignedCourses-tab"
            data-toggle="pill"
            href="#pills-AssignedCourses"
            role="tab"
            aria-controls="pills-AssignedCourses"
            aria-selected="false"
            >Assigned Courses</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            id="pills-SavedCourses-tab"
            data-toggle="pill"
            href="#pills-SavedCourses"
            role="tab"
            aria-controls="pills-SavedCourses"
            aria-selected="false"
            >Saved Courses</a
          >
        </li>
      </ul>
      <div class="tab-content" id="pills-tabContent">
        <!-- <div
          class="tab-pane fade show active"
          id="pills-LearningHistory"
          role="tabpanel"
          aria-labelledby="pills-LearningHistory-tab"
        >
          <div class="text-center emptyLearning py-5 mt-5">
            <div class="font20 d-flex align-items-center m-auto">
              <img src="assets/icons/info.png" alt="" />
              <div class="ml-3 font-light">
                You don’t have any completed courses yet.
              </div>
            </div>
            <div class="py-4">
              <img src="assets/images/award.png" alt="" />
            </div>
            <p class="font14 font-light">
              When you complete a course you will find it here.<br />
              Start tsaking courses that might interest you.
            </p>
            <div>
              <button class="btn btn-primary mt-4 rounded p-3">
                See Recomended Courses
              </button>
            </div>
          </div>
        </div> -->
        <div
          class="tab-pane fade show active fade mt-4 "
          id="pills-EnrolledCourses"
          role="tabpanel"
          aria-labelledby="pills-EnrolledCourses-tab"
        >
          <div class="row section-content">
            <div
              class="text-center emptyLearning py-5 mt-5"
              *ngIf="enrolledCourses.length == 0"
            >
              <div class="font20 d-flex align-items-center m-auto">
                <img src="assets/icons/info.png" alt="" />
                <div class="ml-3 font-light">
                  You have not enrolled for any course yet
                </div>
              </div>
              <div class="py-2 my-4">
                <img src="assets/images/book.png" alt="" />
              </div>
              <p class="font14 font-light my-4">
                In progress courses will appear here
              </p>
            </div>
            <div
              [routerLink]="[
                '/courses/course-details',
                (course?.course)['code']
              ]"
              class="col-12 col-md-6 col-lg-3 my-4 click"
              *ngFor="
                let course of enrolledCourses
                  | paginate
                    : {
                        id: 'enrolledCourses',
                        itemsPerPage: enrolledCoursesPaginationInfo.size,
                        currentPage: enrolledCoursesPaginationInfo.number,
                        totalItems: enrolledCoursesPaginationInfo.totalElements
                      }
              "
            >
              <div class="bg-white">
                <div>
                  <img
                    src="{{ course?.course?.imageUrl }}"
                    alt=""
                    class="w-100 courseImg"
                  />
                </div>
                <p class="mx-4 mt-4 font-bold">
                  {{ course?.course?.title }} <br />
                  <span class="text-grey font10"
                    >By: {{ course?.course?.company?.name }}</span
                  >
                </p>
                <div class="py-2 mx-4">
                  <div class="progress">
                    <div
                      class="progress-bar"
                      role="progressbar"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      [style.width]="
                        course?.course?.progress == 'NaN'
                          ? 0 + '%'
                          : course?.course?.progress + '%'
                      "
                    ></div>
                  </div>
                  <p class="font-light font12">
                    {{
                      (course?.course?.progress == 'NaN'
                        ? 0
                        : (course?.course?.progress | number: '1.0-0')) + '%'
                    }}
                    Complete
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            class="d-flex justify-content-center my-5 list-nav"
            *ngIf="enrolledCourses.length > 0"
          >
            <div class="d-flex align-items-center sm-flex-column">
              <pagination-controls
                id="enrolledCourses"
                (pageChange)="navigateEnrolledCoursePage($event)"
              ></pagination-controls>
            </div>
          </div>
        </div>
        <!-- <div
          class="tab-pane fade"
          id="pills-EnrolledCourses"
          role="tabpanel"
          aria-labelledby="pills-EnrolledCourses-tab"
        >
          <div class="row section-content">
            <div class="col-12 col-md-3" *ngFor="let course of courses">
              <div class="d-flex justify-content-end">
                <button
                  class="btn btn-link  pt-3 pb-0 px-0 font12"
                  style="text-decoration: none;"
                  data-toggle="modal"
                  data-target="#removeModal"
                >
                  Remove
                </button>
              </div>
              <div class="" routerLink="/courses/details">
                <div class="p-r">
                  <img src="assets/images/course-bg.png" alt="" class="w-100" />
                  <span class="course-duration p-1">40 Mins</span>
                </div>
                <div class="bg-white pb-3">
                  <p class="px-3 pt-3 font-bold">
                    Plan International Nigeria Personnel Manual <br />
                    <span class="text-grey font10">By: Charles Eshimokai</span>
                  </p>
                  <div class="img-rating-header d-flex justify-content-between">
                    <div class="name-rating mx-3 font12">
                      <h5 class="mb-0  text-grey font12">Rating</h5>
                      <div class="rating four">
                        <span>☆</span><span>☆</span><span>☆</span><span>☆</span
                        ><span>☆</span>
                      </div>
                    </div>
                    <div class=" mx-3 font12">
                      <h5 class="mb-0  text-grey font12">Level</h5>
                      <div class="mb-0 text-grey font12">
                        Intermidiate level
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <div
          class="tab-pane fade"
          id="pills-LearningPath"
          role="tabpanel"
          aria-labelledby="pills-LearningPath-tab"
        >
          <div
            class="text-center emptyLearning py-5 mt-5"
            *ngIf="assignedLp.length == 0"
          >
            <div class="font20 d-flex align-items-center m-auto">
              <img src="assets/icons/info.png" alt="" />
              <div class="ml-3 font-light">
                You have not been assigned a learning path
              </div>
            </div>
            <div class="py-2 my-4">
              <img src="assets/images/book.png" alt="" />
            </div>
            <p class="font14 font-light my-4">
              When you are assigned a learning path,you will find it here.
            </p>
          </div>
          <div class="text-center my-5">
            <div class="row mt-3 section-content">
              <div
                class="col-12 col-md-6 col-lg-3 mt-4 click"
                [routerLink]="[
                  '/learningPath/view',
                  assignedLp.learningPath['id']
                ]"
                *ngFor="
                  let assignedLp of assignedLp
                    | paginate
                      : {
                          id: 'assignedLp',
                          itemsPerPage: assignedLpPaginationInfo.size,
                          currentPage: assignedLpPaginationInfo.number,
                          totalItems: assignedLpPaginationInfo.totalElements
                        }
                "
              >
                <div>
                  <div>
                    <img
                      src="{{
                        (assignedLp?.learningPath?.courses)[0]?.imageUrl
                      }}"
                      alt=""
                      class="w-100"
                      style="height: 120px;"
                    />
                  </div>
                  <div class="bg-white px-4 pt-4 pb-3 text-center">
                    <p class="text-blue">
                      {{ assignedLp?.learningPath?.name }}
                    </p>
                    <p
                      class="text-grey font14 font-light"
                      style="height: 95px;"
                    >
                      Learn in your own time and at your own pace by taking our
                      UX Design course. Conduct practical projects to apply what
                      you learn.
                    </p>
                    <button class="btn btn-outline-primary font14">
                      View Path
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="d-flex justify-content-center my-5 list-nav"
              *ngIf="assignedLp.length > 0"
            >
              <div class="d-flex align-items-center sm-flex-column">
                <pagination-controls
                  id="assignedLp"
                  (pageChange)="navigateLpPage($event)"
                ></pagination-controls>
              </div>
            </div>
          </div>
        </div>
        <div
          class="tab-pane fade"
          id="pills-AssignedCourses"
          role="tabpanel"
          aria-labelledby="pills-AssignedCourses-tab"
        >
          <div class="row section-content">
            <div
              class="text-center emptyLearning py-5 mt-5"
              *ngIf="assignedCourses.length == 0"
            >
              <div class="font20 d-flex align-items-center m-auto">
                <img src="assets/icons/info.png" alt="" />
                <div class="ml-3 font-light">
                  You have no assigned courses yet
                </div>
              </div>
              <div class="py-2 my-4">
                <img src="assets/images/book.png" alt="" />
              </div>
              <p class="font14 font-light my-4">
                Assigned courses will appear here
              </p>
            </div>

            <div
              class="col-12 col-md-6 col-lg-3 my-4 click"
              [routerLink]="[
                '/courses/course-details',
                assignedLpPaginationInfo['code']
              ]"
              *ngFor="
                let assignedCourse of assignedCourses
                  | paginate
                    : {
                        id: 'assignedCourses',
                        itemsPerPage: assignedCoursesPaginationInfo.size,
                        currentPage: assignedCoursesPaginationInfo.number,
                        totalItems: assignedCoursesPaginationInfo.totalElements
                      };
                index as i
              "
              [routerLink]="[
                '/courses/course-details',
                (assignedCourse?.course)['code']
              ]"
            >
              <div class="bg-white" routerLink="/courses/details">
                <div class="p-r">
                  <img
                    src="{{ assignedCourse?.course?.imageUrl }}"
                    alt=""
                    class="w-100 courseImg"
                  />
                  <span class="course-duration p-1">{{
                    transformDuration(i)
                  }}</span>
                </div>
                <p class="m-3">
                  {{ assignedCourse?.course?.title }} <br />
                  <span class="text-grey font10"
                    >By: {{ assignedCourse?.course?.company?.name }}</span
                  >
                </p>
                <div class="img-rating-header d-flex justify-content-between">
                  <div class=" mx-3 mb-3 font12">
                    <p class="mb-0 mt-0 text-grey font12">
                      Due Date
                    </p>
                    <div style="font-size: 10px; color: #393977">
                      {{ assignedCourse?.dueDate | date }}
                    </div>
                  </div>
                  <div class="name-rating mx-3 mb-3 font12">
                    <h5
                      class="mb-0 mt-2"
                      style="color:  #393977; font-weight: bold;"
                    >
                      <img src="  assets/icons/timer.svg" height="15px" />
                      2 weeks
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="d-flex justify-content-center my-5 list-nav"
            *ngIf="assignedCourses.length > 0"
          >
            <div class="d-flex align-items-center sm-flex-column">
              <pagination-controls
                id="assignedCourses"
                (pageChange)="navigateAssignedCoursePage($event)"
              ></pagination-controls>
            </div>
          </div>
        </div>
        <div
          class="tab-pane fade"
          id="pills-SavedCourses"
          role="tabpanel"
          aria-labelledby="pills-SavedCourses-tab"
        >
          <div class="row section-content">
            <div
              class="text-center emptyLearning py-5 mt-5"
              *ngIf="savedCourses.length == 0"
            >
              <div class="font20 d-flex align-items-center m-auto">
                <img src="assets/icons/info.png" alt="" />
                <div class="ml-3 font-light">
                  You have no saved courses yet
                </div>
              </div>
              <div class="py-2 my-4">
                <img src="assets/images/book.png" alt="" />
              </div>
              <p class="font14 font-light my-4">
                Saved courses will appear here
              </p>
            </div>
            
            <div
              class="col-12 col-md-6 col-lg-3"
              *ngFor="
                let saveCourse of savedCourses
                  | paginate
                    : {
                        id: 'savedCourses',
                        itemsPerPage: savedCoursesPaginationInfo.size,
                        currentPage: savedCoursesPaginationInfo.number,
                        totalItems: savedCoursesPaginationInfo.totalElements
                      };
                index as i
              "
            >
              <div class="d-flex justify-content-end">
                <button
                  class="btn btn-link  pt-3 pb-0 px-0 font12"
                  style="text-decoration: none;"
                  data-toggle="modal"
                  [attr.data-target]="'#modal' + saveCourse.id"
                  id="removeCourse{{ i }}"
                >
                  Remove
                </button>
              </div>
              <label>
                <div
                  class="click"
                  [routerLink]="['courses/course-details', saveCourse?.code]"
                >
                  <div class="p-r">
                    <img
                      src="{{ saveCourse.imageUrl }}"
                      alt=""
                      class="w-100 courseImg"
                    />
                    <span class="course-duration p-1">
                      {{ transformSDuration(i) }}
                    </span>
                  </div>
                  <div class="bg-white pb-3">
                    <p class="px-3 pt-3 font-bold">
                      {{ saveCourse.title }} <br />
                      <span class="text-grey font10"
                        >By: {{ saveCourse.company?.name }}</span
                      >
                    </p>
                    <div
                      class="img-rating-header d-flex justify-content-between"
                    >
                      <div class="name-rating mx-3 font12">
                        <h5 class="mb-0  text-grey font12">Rating</h5>
                        <div class="rating four">
                          <span>☆</span><span>☆</span><span>☆</span
                          ><span>☆</span><span>☆</span>
                        </div>
                      </div>
                      <div class=" mx-3 font12">
                        <h5 class="mb-0  text-grey font12">Level</h5>
                        <div class="mb-0 text-grey font12">
                          {{ saveCourse.level }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </label>
            </div>
          </div>
          <div
            class="d-flex justify-content-center mt-3 sm-flex-column"
            *ngIf="savedCourses.length > 0"
          >
            <pagination-controls
              id="savedCourses"
              (pageChange)="navigateSavedCoursePage($event)"
            ></pagination-controls>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-auto container footer-wrapper">
    <hr />
    <iq-central-front-end-footer></iq-central-front-end-footer>
  </div>
</section>

<!-- Remove Modal -->
<div
  class="modal fade"
  id="removeModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="removeModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class=" modal-header px-4">
        <p class="modal-title font20" id="updateBankModalLabel">Confirm</p>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-4">
        <p class="font18 font-light text-center px-4">
          Are you sure you want to
          <span class="text-blue font-bold">Remove</span> this course? Click the
          'No' button to cancel this action
        </p>
      </div>
      <div class="modal-footer d-flex justify-content-around  text-center p-4">
        <button
          type="button"
          class="btn bg-white btn-outline-secondary"
          data-dismiss="modal"
        >
          No
        </button>
        <button type="button" class="btn btn-secondary">Yes</button>
      </div>
    </div>
  </div>
</div>

<!-- Remove Modal -->
<div
  class="modal fade"
  id="modal{{ saveCourse.id }}"
  tabindex="-1"
  role="dialog"
  aria-labelledby="removeModalLabel"
  aria-hidden="true"
  *ngFor="let saveCourse of savedCourses"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class=" modal-header px-4">
        <p class="modal-title font20" id="updateBankModalLabel">Confirm</p>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-4">
        <p class="font18 font-light text-center px-4">
          Are you sure you want to
          <span class="text-blue font-bold">Remove</span> this course? Click the
          'No' button to cancel this action
        </p>
      </div>
      <div class="modal-footer d-flex justify-content-around  text-center p-4">
        <button
          type="button"
          class="btn bg-white btn-outline-secondary"
          data-dismiss="modal"
        >
          No
        </button>
        <button
          type="button"
          class="btn btn-secondary"
          id="{{ saveCourse.id }}"
          (click)="removeSavedCourse(saveCourse)"
        >
          Yes
        </button>
      </div>
    </div>
  </div>
</div>
